<ng-container *ngIf="items">
    <cds-checkbox-group layout="vertical">
        <ng-container *ngIf="title">
            <label>{{ title }}</label>
        </ng-container>
    </cds-checkbox-group>
    <div class="scroll">
        <cds-checkbox-group layout="vertical">
            <cds-checkbox *ngIf="showSelectAll">
                <label>Select all</label>
                <input type="checkbox" [ngModel]="_allSelected" (change)="toggleAll()" />
            </cds-checkbox>
            <ng-container *ngIf="_selected">
                <ng-container *ngFor="let item of items; index as i">
                    <cds-checkbox>
                        <label>{{ item.name || '-' }}</label>
                        <input
                            type="checkbox"
                            [ngModel]="_selected[i]"
                            [disabled]="isDisabledAt(i)"
                            (change)="change(i)"
                        />
                    </cds-checkbox>
                </ng-container>
            </ng-container>
        </cds-checkbox-group>
    </div>
</ng-container>
